export const canUpgradeFilespace = ({ currentMember, filespace, isEnterprise, }) => Boolean(filespace.canMigrate &&
    currentMember.privileges.migration &&
    isEnterprise);
export const isAbleToUnlockUpgrade = ({ currentMember, filespace, isEnterprise, }) => Boolean(filespace.isMigrating &&
    currentMember.privileges.migration &&
    isEnterprise);
